export const INITIATE_BULK_REFUND_BUTTON = 'initiate-bulkRefund';
export const DOWNLOAD_SAMPLE_FORM = 'download-sample-form';
export const UPLOAD_BUTTON = 'upload-button';
export const UPLOAD_FILE_MODAL_SUBMIT_BUTTON = 'submit-button';
export const UPLOAD_FILE_MODAL_CANCEL_BUTTON = 'cancel-button';
export const UPLOAD_FILE_MODAL_NEXT_BUTTON = 'next-button';
export const LEARN_FILE_FORMAT_BUTTON = 'learn-file-format-button';
export const INPUT_NAME_FIELD = 'input-name-field';
export const INPUT_REFUND_REASON_FIELD = 'input-reason-field';
export const SUCCESS_MODAL_FOOTER_BUTTON = 'success-modal-footer-button';
export const BATCH_REFUND_LOADER = 'batch-refund-loader';
export const BATCH_REFUND_FILE_UPLOAD_MODAL = 'batch-refund-file-upload-modal';
export const BATCH_REFUND_SAMPLE_FILE_MODAL = 'sample-file-format-modal-id';
export const BATCH_REFUND_SAMPLE_FILE_FOOTER_BUTTON = 'sample-file-modal-footer-button';
export const BATCH_REFUND_POPOVER_ICON = 'batch-refund-popover-infoIcon';
